import { create } from 'zustand';

export enum NotificationType {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
}

interface INotification {
  type: NotificationType;
  message: string | null | undefined;
}

interface NotificationStore {
  notification: INotification | null;
  setError: (message: string | null | undefined) => void;
  setSuccess: (message: string | null | undefined) => void;
  setWarning: (message: string | null | undefined) => void;
  clear: () => void;
}

export const useNotificationStore = create<NotificationStore>((set) => {
  let timeoutId: NodeJS.Timeout | null = null;

  return {
    notification: null,

    setError: (message) => {
      if (timeoutId) clearTimeout(timeoutId);

      set({ notification: message ? { type: NotificationType.ERROR, message } : null });

      timeoutId = setTimeout(() => {
        set({ notification: null });
        timeoutId = null;
      }, 5000);
    },

    setSuccess: (message) => {
      if (timeoutId) clearTimeout(timeoutId);

      set({ notification: message ? { type: NotificationType.SUCCESS, message } : null });

      timeoutId = setTimeout(() => {
        set({ notification: null });
        timeoutId = null;
      }, 5000);
    },

    setWarning: (message) => {
      if (timeoutId) clearTimeout(timeoutId);

      set({ notification: message ? { type: NotificationType.WARNING, message } : null });

      timeoutId = setTimeout(() => {
        set({ notification: null });
        timeoutId = null;
      }, 5000);
    },

    clear: () => {
      if (timeoutId) clearTimeout(timeoutId);
      set({ notification: null });
    },
  };
});
